/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 利用年齢制限パネル（年齢入力）
 *
 * @author ykobayashi
 * @copyright Copyright 2022 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-age-limit-input-form-pane">

  <el-main class="main-area">
    <p class="age-limit-input-form-text" v-text="ageLimitConfirmText"></p>
    <el-form ref="ageLimitInputForm" :model="fastchatAgeInfo" :rules="rules" @submit.native.prevent="doCheck">
      <div class="form-item-container">
        <el-form-item :label="'生年月日'" :prop="'birthday'" class="form-item">
          <div style="clear: left">
            <el-date-picker type="date" placeholder="1969/08/01" v-model="fastchatAgeInfo['birthday']" :disabled="!permissionInputAgeLimitInputForm" format="yyyy/MM/dd" value-format="yyyy/MM/dd" class="date-select" @blur="dateValidate($event, 'birthday')">
            </el-date-picker>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </el-main>
  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="age-limit-check-button" :disabled="!permissionNextStep" @click="doCheck">{{checkButtonLabel}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Form,
  FormItem,
  DatePicker,
  Button
} from 'element-ui'

export default {
  name: 'FcAgeLimitInputFormPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-date-picker': DatePicker,
    'el-button': Button
  },
  data() {
    return {
      /**
       * FastChat年齢情報
       * @type {Object}
       */
      fastchatAgeInfo: {},
      /**
       * 生年月日入力フォームルール
       * @type {Object}
       */
      rules: {},
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,
      /**
       * チャット年齢情報のvalid状態
       * @type {Boolean}
       */
      validFastchatAgeInfo: false,
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: false
    }
  },
  beforeMount() {
    // fastchatAgeInfoとrulesを設定
    this.$set(this.fastchatAgeInfo, 'birthday', '')
    this.rules['birthday'] = [{
      required: true,
      message: '生年月日 を入力してください',
      trigger: 'blur'
    }]
  },
  mounted() {
    // チャット年齢情報のvalid状態を更新
    this.validateFastchatAgeLimitInputForm((valid) => {
      this.validFastchatAgeInfo = valid
    })
  },
  updated() {
    // チャット年齢情報のvalid状態を更新
    this.validateFastchatAgeLimitInputForm((valid) => {
      this.validFastchatAgeInfo = valid
    })
  },
  computed: {
    /**
     * 入力説明内容
     * @return {string}
     */
    ageLimitConfirmText() {
      return this.$config.ageLimitDisplayConfig.ageLimitConfirmText
    },
    /**
     * 年齢確認ボタンラベル
     * @return {string}
     */
    checkButtonLabel() {
      return this.$config.ageLimitDisplayConfig.ageLimitCheckButtonLabel
    },
    /**
     * 次のステップを実行が可能か
     * @return {Boolean}
     */
    permissionNextStep() {
      return !this.requestingFindFastchatServiceStatus && this.validFastchatAgeInfo && !this.disabled
    },
    /**
     * 年齢確認入力フォームへの入力が可能か
     * @return {Boolean}
     */
    permissionInputAgeLimitInputForm() {
      return !this.requestingFindFastchatServiceStatus && !this.disabled
    }
  },
  methods: {
    /**
     * チャット年齢確認フォームのvalidate処理
     * @param  {Function} callback
     */
    validateFastchatAgeLimitInputForm(callback) {
      this.$refs['ageLimitInputForm'].validate((valid) => {
        callback(valid)
      })
    },
    /**
     *日付の入力欄チェック
     */
    dateValidate(obj, modelColumnKey) {
      let dateReg = new RegExp(/^([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))$/)
      if (obj && obj.userInput && !obj.userInput.match(dateReg)) {
        // 日付の入力欄に日付フォーマット以外のものが入力された際にクリア
        this.fastchatAgeInfo[modelColumnKey] = null
        obj.userInput = ''
      }
    },
    /**
     * 顧客入力フォームをクリア
     **/
    clearAgeLimitInputForm() {
      if (this.$refs['ageLimitInputForm']) {
        this.$refs['ageLimitInputForm'].resetFields()
      }
    },
    /**
     * 年齢確認ボタン処理
     */
    doCheck() {
      this.validateFastchatAgeLimitInputForm((valid) => {
        if (valid) {
          // 生年月日が正しく入力されている場合
          let birthday = new Date(this.fastchatAgeInfo['birthday'])
          let ageLimitValue = this.$config.ageLimitDisplayConfig.ageLimitValue
          let today = new Date(this.$config.ageLimitDisplayConfig.systemDate)
          // 現在の年齢算出
          let userAge = today.getFullYear() - birthday.getFullYear()
          let bd = new Date(today.getFullYear(), birthday.getMonth(), birthday.getDate())
          if (today < bd) {
            userAge = (userAge - 1)
          }
          // alert('現在年齢：' + userAge + " , 対象年齢：" + ageLimitValue)
          // 年齢の確認
          if (ageLimitValue <= userAge) {
            // 指定年齢以上の場合
            this.$_setBirthday(this.fastchatAgeInfo['birthday'])
            this.$emit('ageLimitCheck')
          } else {
            // 指定年齢未満の場合
            this.$emit('ageLimitExclude')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.fc-age-limit-input-form-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.age-limit-check-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/ageLimit/FcAgeLimitInputFormPane.vue